import { NetworkStatus } from '@cbridge-utils/network';
import { IRoutingRuleStore } from './routingRule.interface';

export const routingRuleInitialState: IRoutingRuleStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
